import styled from 'styled-components';

import { FullWidthContainer } from '#src/atoms/layout/FullWidthContainer/index.tsx';
import { BodyM } from '#src/atoms/typography/index.tsx';
import { SocialLinks } from '#src/atoms/ui/SocialMedias/index.tsx';
import { LanguageSwitcher } from '#src/components/user/LanguageSwitcher/index.tsx';
import { useIsLoggedIn } from '#src/hooks/auth/useIsLoggedIn.ts';
import { useIsMobileApp } from '#src/hooks/useIsMobileApp.ts';
import { copyright } from '#src/lib/copyright.ts';
import { tabletAndAbove } from '#src/style/mediaQuery.ts';

import { FooterLinks } from './FooterLinks.tsx';
import { SocialLinksConfig as socialLinks } from './socialLinks.ts';

const Footer = styled.footer`
  background: var(--c-black);
  color: var(--c-white);
`;
const CopyAndLanguage = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: var(--double-unit);
  padding: var(--double-unit) 0;
  @media ${tabletAndAbove} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;
const CopyContainer = styled(BodyM)`
  @media ${tabletAndAbove} {
    text-align: right;
  }
`;

export const MultiSportFooter = () => {
  const isLoggedIn = useIsLoggedIn();
  const { isMobileApp } = useIsMobileApp();

  if (isMobileApp) return null;

  if (isLoggedIn) return null;

  return (
    <Footer>
      <FullWidthContainer>
        <SocialLinks socialLinks={socialLinks} />
        <FooterLinks />
        <CopyAndLanguage>
          <LanguageSwitcher />
          <CopyContainer>{copyright}</CopyContainer>
        </CopyAndLanguage>
      </FullWidthContainer>
    </Footer>
  );
};
